
        var result = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./ngx-select-dropdown.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/components/ngx-select-dropdown-component/ngx-select-dropdown.component.scss
// module id = 10
// module chunks = 0 1